import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const searchOrder = async function (orderNo) {
  try {
    var data = {
      shipmentNo: orderNo,
    }
    const res = await axios.get(urls.getOrderDetail + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  searchOrder,
}
